import { DocumentCard, Faq } from 'sections/Resources/FreightTemplates/CertificateOfOrigin/types';

export const documentsCardData: DocumentCard[] = [
  {
    id: 1,
    iconName: 'icon-files.svg',
    heading: 'Commercial Invoice',
    url: '/resources/freight-templates/commercial-invoice',
    fileName: 'commercial_invoice',
  },
  {
    id: 2,
    iconName: 'icon-files.svg',
    heading: 'Packing List',
    url: '/resources/freight-templates/packing-list',
    fileName: 'packing_list',
  },
  {
    id: 3,
    iconName: 'icon-files.svg',
    heading: 'Proforma Invoice',
    url: '/resources/freight-templates/proforma-invoice',
    fileName: 'proforma_invoice',
  },
];

export const faq: Faq[] = [
  {
    id: "1",
    question: "Can I just print one out and sign it myself?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Usually, no. Most countries require the CO to be authenticated by a Chamber of Commerce. Self-certification is allowed in some modern trade agreements, but you need to be sure before you try it.
        </p>
      `
    ),
  },
  {
    id: "2",
    question: "What is a 'Statement of Origin' then?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          That’s the simplified version. Some newer FTAs allow exporters to just type a specific declaration on the invoice instead of getting a separate formal certificate. Always check the rules of the specific trade deal.
        </p>
      `
    ),
  },
  {
    id: "3",
    question: "Can I reuse the same template for every shipment?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          The layout, yes. The data, no. The origin criteria might change depending on the raw materials used in that specific batch. You have to be accurate every time.
        </p>
      `
    ),
  },
  {
    id: "4",
    question: "How do I know if I qualify for zero duty?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          You need to check the "Rules of Origin" for the destination country. Just because you shipped it from Dubai doesn't mean it's "Made in UAE." The CO must reflect the actual manufacturing origin.
        </p>
      `
    ),
  },
];